import { makeAutoObservable } from 'mobx';
import { groupByFunction } from './utils/rxjs/groupByFunction';

export class WatchlistStore {
  root;
  watchlists = {};
  watchlistsSubject;

  constructor(root) {
    makeAutoObservable(this);
    this.root = root;
    this.initializeStream();
  }

  initializeStream = () => {
    this.watchlistsSubject = groupByFunction(
      'messageType',
      'watchlists',
      this.root.websocketSubject
    ).subscribe(this.handleWatchlistMsg);
  };

  handleWatchlistMsg = (msg) => {
    const storeObj = {};
    msg.watchlists.watchlist.forEach(watchlist => {
      storeObj[watchlist.watchlist_name] = watchlist.symbols;
    });
    this.watchlists = storeObj;
  };
}
/*
{
	"messageType": "watchlists",
	"watchlists": {
		"watchlist": [{
				"watchlist_name": "__tradeIdeas1589193663542",
				"symbols": [{
					"symbol": "FB",
					"dataSource": "LIVE"
				}]
			},
			{
				"watchlist_name": "test",
				"symbols": [{
					"symbol": "GM",
					"dataSource": "LIVE"
				}]
			},
			{
				"watchlist_name": "TEST",
				"symbols": [{
					"symbol": "EA",
					"dataSource": "LIVE"
				}]
			},
			{
				"watchlist_name": "__positions",
				"symbols": [{
						"symbol": "MSFT",
						"dataSource": "LIVE"
					},
					{
						"symbol": "AAPL",
						"dataSource": "LIVE"
					}, {
						"symbol": "AMC",
						"dataSource": "LIVE"
					},
					{
						"symbol": "XOM",
						"dataSource": "LIVE"
					}, {
						"symbol": "AMD",
						"dataSource": "LIVE"
					},
					{
						"symbol": "RIOT",
						"dataSource": "LIVE"
					}, {
						"symbol": "PM",
						"dataSource": "LIVE"
					},
					{
						"symbol": "SPY",
						"dataSource": "LIVE"
					}, {
						"symbol": "WISH",
						"dataSource": "LIVE"
					}
				]
			},
			{
				"watchlist_name": "testing",
				"symbols": []
			}, {
				"watchlist_name": "name",
				"symbols": [{
					"symbol": "GOOG",
					"dataSource": "LIVE"
				}, {
					"symbol": "SPOT",
					"dataSource": "LIVE"
				}, {
					"symbol": "W",
					"dataSource": "LIVE"
				}, {
					"symbol": "RNG",
					"dataSource": "LIVE"
				}]
			}, {
				"watchlist_name": "__tradeIdeas1589193666542",
				"symbols": []
			}, {
				"watchlist_name": "vTrading",
				"symbols": [{
					"symbol": "M",
					"dataSource": "LIVE"
				}, {
					"symbol": "GME",
					"dataSource": "LIVE"
				}]
			}, {
				"watchlist_name": "__tradeIdeas1589380527277",
				"symbols": [{
					"symbol": "AMZN",
					"dataSource": "LIVE"
				}]
			}, {
				"watchlist_name": "symbols",
				"symbols": [{
					"symbol": "FB",
					"dataSource": "LIVE"
				}, {
					"symbol": "GM",
					"dataSource": "LIVE"
				}, {
					"symbol": "EA",
					"dataSource": "LIVE"
				}, {
					"symbol": "MSFT",
					"dataSource": "LIVE"
				}, {
					"symbol": "AAPL",
					"dataSource": "LIVE"
				}, {
					"symbol": "AMC",
					"dataSource": "LIVE"
				}, {
					"symbol": "XOM",
					"dataSource": "LIVE"
				}, {
					"symbol": "AMD",
					"dataSource": "LIVE"
				}, {
					"symbol": "RIOT",
					"dataSource": "LIVE"
				}, {
					"symbol": "PM",
					"dataSource": "LIVE"
				}, {
					"symbol": "SPY",
					"dataSource": "LIVE"
				}, {
					"symbol": "WISH",
					"dataSource": "LIVE"
				}, {
					"symbol": "GOOG",
					"dataSource": "LIVE"
				}, {
					"symbol": "SPOT",
					"dataSource": "LIVE"
				}, {
					"symbol": "W",
					"dataSource": "LIVE"
				}, {
					"symbol": "RNG",
					"dataSource": "LIVE"
				}, {
					"symbol": "M",
					"dataSource": "LIVE"
				}, {
					"symbol": "GME",
					"dataSource": "LIVE"
				}, {
					"symbol": "AMZN",
					"dataSource": "LIVE"
				}]
			}
		]
	}
}*/
